import { serviceBillingTriggerOptions } from '~/business-logic/billingLogic';
import { ServiceCostType } from '~/models/service-cost';
import { BillingTriggerType } from '~/types/api.model';
const pricingTypeMap = {
    range: ServiceCostType.Range,
    fixed: ServiceCostType.Fixed,
    unit: ServiceCostType.Variable,
    hour: ServiceCostType.Variable
};
const billingTriggerMap = {
    ongoing: BillingTriggerType.Ongoing,
    approval: BillingTriggerType.OnApproval,
    manualFixed: BillingTriggerType.OneTimeManual,
    manualVariable: BillingTriggerType.OneTimeManual,
    oneTimeInStages: BillingTriggerType.OneTimeInStages,
    onDemand: BillingTriggerType.OnDemand
};
export function getBillingTriggerOptionsForFormState(param) {
    let { t, data, serviceOrigin, isExistingService, featureFlags } = param;
    const { recurrencePeriod, pricing, trigger } = data;
    return serviceBillingTriggerOptions({
        t,
        featureFlags,
        isExistingService,
        isFromAgreement: serviceOrigin === 'agreement',
        recurrencePeriod: recurrencePeriod === 'onetime' || recurrencePeriod === 'inStages' || recurrencePeriod === 'onDemand' ? null : recurrencePeriod,
        pricingType: pricingTypeMap[pricing],
        billingTrigger: billingTriggerMap[trigger]
    });
}
const manualTriggers = [
    'manualFixed',
    'manualVariable'
];
function isManualTrigger(trigger) {
    return manualTriggers.includes(trigger);
}
export function getUpdatedTriggerIfInvalid(param) {
    let { t, currentTrigger, pricing, recurrencePeriod, serviceOrigin, isExistingService, featureFlags } = param;
    var _newOptions_;
    if (recurrencePeriod === 'onDemand') return currentTrigger === 'onDemand' ? null : 'onDemand';
    const newOptions = getBillingTriggerOptionsForFormState({
        t,
        data: {
            recurrencePeriod,
            pricing,
            trigger: currentTrigger
        },
        serviceOrigin,
        isExistingService,
        featureFlags
    });
    if (newOptions.some((opt)=>opt.value === currentTrigger)) return null;
    if (isManualTrigger(currentTrigger)) {
        const manualReplacement = newOptions.find((opt)=>isManualTrigger(opt.value));
        if (manualReplacement) return manualReplacement.value;
    }
    return ((_newOptions_ = newOptions[0]) === null || _newOptions_ === void 0 ? void 0 : _newOptions_.value) || 'manualVariable';
}
